import { Accordion, Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

import { devices } from '../../../../../config/devices';

export const TableContainer = styled.div`
  width: 100%;
  @media ${devices.xs} {
    width: 300px;
  }
`;

export const useClasses = makeStyles({
  switch_thumb: {
    border: `2px solid #F35252`,
  },
  switch_track: {
    backgroundColor: '#D72C31',
  },
});

export const GroupMembersField = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  svg {
    margin-right: 15px;
  }
`;

export const StyledAccordion = styled(Accordion)`
  width: 100%;
  box-shadow: none !important;
  border: 1px solid rgba(25, 25, 25, 0.32) !important;
  border-radius: 6px !important;
  margin-bottom: 10px;

  '&:before'{
    display:none;
  } 
  
  
  
  .MuiAccordionSummary-root.Mui-expanded {
    border-bottom: 1px solid rgba(25, 25, 25, 0.32) !important;
    min-height: 48px !important;
  }

  .gGkPVc .MuiAccordionDetails-root {
    padding: 15px 0;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
  }

  .MuiAccordionDetails-root {
    padding: 15px 0;
    display: block;
  }
`;

export const AccordionBoxes = styled(Box)`
  display: flex;
  padding: 10px 55px;

  .boxTitle {
    margin-right: 10px;
    text-transform: uppercase;
    color: #757575;
    font-weight: 500;
  }
`;

export const StyledPhoneInput = styled.div`
  position: relative;
  .jyfbTZ {
    margin-top: 0 !important;
  }
  .spanLabel {
    position: absolute;
    z-index: 1;
    top: -8px;
    left: 75px;
    background-color: white;
    padding: 0 5px;
  }
`;
export const StyledFieldView = styled(Grid)`
  .MuiFormControl-marginNormal {
    margin-top: 0;
    margin-bottom: 0;
  }

  .MuiFormControl-root {
    margin-bottom: 0;
  }
`;
